var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckboxUnchecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    stroke: "#B6BEBF",
    d: "M5.1277704,0.5 C3.5776195,0.5 2.94057806,0.623018378 2.28210802,0.975172007 C1.71739041,1.27718629 1.27718629,1.71739041 0.975172007,2.28210802 C0.623018378,2.94057806 0.5,3.5776195 0.5,5.1277704 L0.5,18.8722296 C0.5,20.4223805 0.623018378,21.0594219 0.975172007,21.717892 C1.27718629,22.2826096 1.71739041,22.7228137 2.28210802,23.024828 C2.94057806,23.3769816 3.5776195,23.5 5.1277704,23.5 L18.8722296,23.5 C20.4223805,23.5 21.0594219,23.3769816 21.717892,23.024828 C22.2826096,22.7228137 22.7228137,22.2826096 23.024828,21.717892 C23.3769816,21.0594219 23.5,20.4223805 23.5,18.8722296 L23.5,5.1277704 C23.5,3.5776195 23.3769816,2.94057806 23.024828,2.28210802 C22.7228137,1.71739041 22.2826096,1.27718629 21.717892,0.975172007 C21.0594219,0.623018378 20.4223805,0.5 18.8722296,0.5 L5.1277704,0.5 Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxUnchecked);
export default __webpack_public_path__ + "static/media/checkbox-unchecked.83993fd5.svg";
export { ForwardRef as ReactComponent };